import { render, staticRenderFns } from "./favorite-card.vue?vue&type=template&id=84990198&scoped=true&lang=pug&"
import script from "./favorite-card.vue?vue&type=script&lang=js&"
export * from "./favorite-card.vue?vue&type=script&lang=js&"
import style0 from "./favorite-card.vue?vue&type=style&index=0&id=84990198&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84990198",
  null
  
)

export default component.exports